import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  DashboardMetrics,
  DashboardPendingActionsCount,
  RecalculateResponse,
  RecalculateStatusResponse,
} from '../../models/dashboard-metrics';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  http = inject(HttpClient);

  getDashboardMetrics(): Observable<DashboardMetrics> {
    return this.http.get<DashboardMetrics>(
      `${environment.apiBaseUrl}/api/dashboard/metrics`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  recalculateDashboardMetrics(): Observable<RecalculateResponse> {
    return this.http.post<RecalculateResponse>(
      `${environment.apiBaseUrl}/api/dashboard/metrics/recalculate`,
      {},
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  getRecalculateStatus(): Observable<RecalculateStatusResponse> {
    return this.http.get<RecalculateStatusResponse>(
      `${environment.apiBaseUrl}/api/dashboard/metrics/recalculate-status`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  getDashboardPendingActionsCount(): Observable<DashboardPendingActionsCount> {
    return this.http.get<DashboardPendingActionsCount>(
      `${environment.apiBaseUrl}/api/dashboard/pending-actions`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
